import React, { useState } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import styled from 'styled-components';
import Popup from 'reactjs-popup';
import Hit from '../assets/HIT.jpg';
import IonNameImg from '../assets/ion_name.jpg';
import NumericInput from 'react-numeric-input';
import {runHit} from '../actions';
import WaitModal from './waitModal';
import TutorialModal from './tutorialModal';
import TCLFile from '../assets/merge.tcl';

import {isMobile } from 'react-device-detect';

function HitTool(props) {

  const [ionName, setIonName] = useState('');
  const [ionsNumber, setIonsNumber] = useState('');
  const [cubeSize, setCubeSize] = useState(3.3);
  const [mergeFile, setMergeFile] = useState('');
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isTutorialOpen, setTutorialIsShown] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }


  function openTutorial(){
    setTutorialIsShown(true);
  }

  function closeTutorial(){
    setTutorialIsShown(false);
  }

  function downloadSetupTools(){
    window.location.href = TCLFile;
  }


  const PostValues = ()=> {
     openModal();

     const {runHit} = props;

     runHit(ionName, ionsNumber, cubeSize, mergeFile, ()=>closeModal());

  };

  return (
    <Container>
      <HeaderContainer>
        <Desc>This tool calculates the positions of the trapped ions from highly charged biomolecule systems based on a molecular dynamic simulation with explicit solvent model</Desc>
          <RoundButton onClick={() => openTutorial()} onMouseEnter={() => openTutorial()}  >?</RoundButton>
      </HeaderContainer>

      <SubContainer isMobile={isMobile}>
        <Img src={Hit}/>
        <InputContainer>
          <StyledPopup
          trigger={open => (
              <Button color="#3B84E5"  marginBottom="20px" onClick={()=>downloadSetupTools()}> Input file preparation </Button>
              )}
              position="top center"
              on={['hover', 'focus']}
              closeOnDocumentClick
            >
            <P2>Download and apply the TCL file in VMD to prepare the input file</P2>
            </StyledPopup>
        <Form>

          <Label>
            <IonNameContainer>
            <P3>Ion Name: &nbsp; </P3>
            <StyledPopup
            trigger={open => (
                    <P> (How to find it)</P>
                )}
                position="top center"
                on={['hover', 'focus']}
                closeOnDocumentClick
              >
                <PopupImg src={IonNameImg}/>
              </StyledPopup>


            </IonNameContainer>
            <input onChange={event => setIonName(event.target.value)} type="text" name="ionName" />
          </Label>
          <Label>
            Ions Number:
            <input onChange={event => setIonsNumber(event.target.value)} type="text"  name="ionsNumber" />
          </Label>
          <Label>
            Cube Size (Å):
            <NumericInput
                onChange={valueAsNumber => setCubeSize(valueAsNumber)}
                step={0.1}
                precision={1}
                value={cubeSize}
                />
          </Label>
          <Label>
            Upload merge.pdb file:
            <input onChange={event => setMergeFile(event.target.files[0])} type="file" name="mergeFile" accept=".pdb" />
          </Label>
        </Form>
          <Button color="#7eb35b" marginTop="20px" onClick={()=>PostValues()}> Submit </Button>
         </InputContainer>


      </SubContainer>

      <WaitModal modalIsOpen={modalIsOpen} closeModal={()=>closeModal()} />
      <TutorialModal isTutorialOpen={isTutorialOpen} closeTutorial ={ () =>  closeTutorial()} />

    </Container>

  );
}

const Container = styled.div`
  family-font:'Fira Sans';
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: ${props=> props.isMobile ? "column" : "row"};
  justify-content: space-around;
  align-items:center;
`;

const InputContainer = styled.div`
`;

const Img = styled.img`
	height: 31vw;
  max-width:652px;
`;

const PopupImg = styled.img`
  height:250px;
`;

const Form = styled.form`
  display:flex;
  flex-direction:column;
`;

const Label = styled.label`
  display:flex;
  flex-direction:column;
  font-size:15px;
`;

const IonNameContainer = styled.div`
  display:flex;
  flex-direction:row;
`;

const P = styled.p`
  text-decoration: underline;
  margin-bottom:0px;
  &:hover {
   cursor:pointer;
  }


`;

const P3 = styled.div`
  margin-bottom:0px;
`;

// const Input = styled.input`
//   background: transparent;
//   border-radius: 5px;
//   border: 1px solid #0095FF;
// `;


const Button = styled.button`
		border: none;
		width: 200px;
		height:50px;
		margin-right:10px;
		color: #fff;
		background-color: ${props => props.color};
		font-size: 1.2em;
		transform-style: preserve-3d;
		outline: none;
		cursor: pointer;
		border-radius: 0.27em;
		text-align: center;
		font-family:'Fira Sans';
    box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
    margin-bottom:${props => props.marginBottom};
    margin-top:${props => props.marginTop};
`;



  //background-color: #69ACC7;
const RoundButton = styled.button`
     display: inline-block;
     height: 40px;
     width: 60px;
     margin: 26px;

     border-radius: 190px;
     border: 2px solid #27ae60;
     background: #2ecc71;
     text-align: center;
     box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
     text-decoration: none;
     color: #fff;

     &:hover {
      cursor:pointer;
     }
`;

const Desc = styled.div`
    font-size:22px;
    margin-bottom:40px;
`;

const HeaderContainer = styled.div`
  display:flex;
  width: 100%;
  justify-content:space-between;
  align-items:center;
  font-size:18px;
`;

const P2 = styled.p`
  font-family:'Fira Sans';
  margin-top:10px;
  margin-right: 5px;
  margin-left: 5px;
`;

const StyledPopup = styled(Popup)`

  &-overlay {
    position: fixed;
    inset: 0px;
    z-index: 999;
    pointer-events: none;
    background: transparent;
  }

  &-content {
    position: absolute;
    z-index: 999;
    pointer-events: auto;
    top: 187.5px;
    left: 626.766px;
    box-shadow: 0 0 3px rgb(0 0 0 / 16%);
    border-radius: 5px;
  }

  &-arrow{

    -webkit-filter: drop-shadow(0 -3px 3px rgba(0,0,0,.16));
    filter: drop-shadow(0 -3px 3px rgba(0,0,0,.16));
    color: #fff;
    stroke-width: 2px;
    stroke: #d7d7d7;
    stroke-dasharray: 30px;
    stroke-dashoffset: -54px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

`;


const mapDispatchToProps = dispatch => {

  return bindActionCreators({runHit}, dispatch);

};


export default connect(null,mapDispatchToProps)(HitTool);



// WEBPACK FOOTER //
// ./src/components/hitTool.js